import { applyIdeaUiOverride, IdeaUiOverride } from "@/lib/ideaUi";
import { Idea } from "@/schemas/firestore/idea.schema";
import { useStore } from "@/store";

export interface IdeasResult {
  ideas: Idea[];
  isLoadingIdeas: boolean;
  ideasError: string | null;
  ideaUiOverrides: Record<string, IdeaUiOverride>;

  subscribeToIdeas: (orgId: string, domainId: string) => () => void;
  clearIdeas: () => void;
  unsubscribeIdeas: () => void;
  markIdeaCreatePending: (
    userId: string,
    domainId: string,
    ideaId: string,
    options?: {
      pageId?: string | null;
      wpType?: "posts" | "pages";
      startedAt?: number;
      expiresAt?: number;
    },
  ) => void;
  resolveIdeaAsImplemented: (
    userId: string,
    domainId: string,
    ideaId: string,
    pageId?: string | null,
    pageType?: "post" | "page" | null,
  ) => void;
  clearIdeaUiOverride: (
    userId: string,
    domainId: string,
    ideaId: string,
  ) => void;
}

export const useIdeas = (domainId?: string): IdeasResult => {
  const {
    ideas: allIdeas,
    isLoadingIdeas,
    ideasError,
    ideaUiOverrides,
    subscribeToIdeas,
    clearIdeas,
    unsubscribeIdeas,
    markIdeaCreatePending,
    resolveIdeaAsImplemented,
    clearIdeaUiOverride,
  } = useStore();

  const ideas = (domainId
    ? allIdeas.filter((i) => i.domain_id === domainId)
    : allIdeas
  ).map((idea) => applyIdeaUiOverride(idea, ideaUiOverrides[idea.id]));

  return {
    ideas,
    isLoadingIdeas,
    ideasError,
    ideaUiOverrides,
    subscribeToIdeas,
    clearIdeas,
    unsubscribeIdeas,
    markIdeaCreatePending,
    resolveIdeaAsImplemented,
    clearIdeaUiOverride,
  };
};
